import { RouterProps } from "./RouterProps.types";
import { BaseErrorPage } from "./components/BaseErrorPage";

export const NotFound: React.FC<RouterProps> = ({ default: _default }) => {

	return (
		<BaseErrorPage
			errorCode="404"
			title="Page Not Found"
		>
			The page you are looking for might have been removed <br /> or is
			temporarily unavailable.
		</BaseErrorPage>
	);
};
